export default __webpack_public_path__ + "static/paris-mobile-fcebe981d82950f0cde578f5b915ff62.png";